var map = {
	"./1.png": "5b82",
	"./2.png": "78f6",
	"./3.png": "9fdf",
	"./4.png": "a910",
	"./5.png": "aa6f",
	"./6.png": "7a59",
	"./aboutimgfive.png": "6286",
	"./banner.png": "15f0",
	"./bg.png": "08fb",
	"./bg1.png": "4d36",
	"./digimgeight.png": "4d55",
	"./digimgeleven.png": "9e2d",
	"./digimgfive.png": "7303",
	"./digimgfour.png": "4c93",
	"./digimgfourteen.png": "b5a5",
	"./digimgnine.png": "5ae3",
	"./digimgone.png": "7ebb",
	"./digimgseven.png": "8799",
	"./digimgsix.png": "38d8",
	"./digimgten.png": "d9e1",
	"./digimgthere.png": "e032",
	"./digimgthirteen.png": "c9aa",
	"./digimgtwelve.png": "30c0",
	"./digimgtwo.png": "21fc",
	"./left.png": "7b2a",
	"./logo.png": "c92c",
	"./nav.png": "2047",
	"./number.png": "f99b",
	"./right.png": "98c1",
	"./zixun.png": "0140",
	"./数字.png": "c72e",
	"./数字化运营.png": "b604",
	"./治理.png": "282b",
	"./流程.png": "5b20",
	"./运营.png": "e294"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81c3";